const Footer = () => {
  return (
    <div className="d-flex gap-5 justify-content-center">
      <p className="clearfix mb-0">
        <span className="float-md-start d-block d-md-inline-block mt-25">
          COPYRIGHT © {new Date().getFullYear()}{" "}
          <a
            href="https://test.nftydoor.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#000", fontWeight: 600 }}
          >
            NFTYDoor
          </a>
          <span className="d-none d-sm-inline-block">
            , All rights Reserved
          </span>
        </span>
      </p>
    </div>
  );
};

export default Footer;
